import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from './../icon';
import './articleExtra.css';

const ArticleExtra = props => {
  const iconStyle = {};
  if (props.iconFill) {
    iconStyle['fill'] = props.iconFill;
  }
  const iconBoxStyle = {};
  if (props.iconCircleFill) {
    iconBoxStyle['backgroundColor'] = props.iconCircleFill;
  }
  return (
    <div className="article-extra">
      <div className="icon-box" style={iconBoxStyle}>
        {props.iconSrc ? (
          <img src={props.iconSrc} alt=""/>
        ) : (
          <Icon name={props.icon} style={iconStyle} />
        )}
      </div>
      <div className="author">
        <span className="text-uppercase">{props.title}</span>
        {props.extra ? (
          <span>
            , <time className="text-primary">{props.extra}</time>
          </span>
        ) : null}
      </div>
    </div>
  );
};

ArticleExtra.propTypes = {
  icon: PropTypes.string,
  iconSrc: PropTypes.string,
  iconFill: PropTypes.string,
  iconCircleFill: PropTypes.string,
  title: PropTypes.string.isRequired,
  extra: PropTypes.string,
};

export default ArticleExtra;



// WEBPACK FOOTER //
// ./src/ui/src/component/article/articleExtra.js